export const calculateNewDiscount = (currentDiscount: number, currentQuantity: number, newQuantity: number, typeDiscount: boolean) => {
    return typeDiscount ? (currentDiscount / currentQuantity) * newQuantity  : currentDiscount;
};

export const initializeProducts = (selectedProducts: any) => {
    return selectedProducts.map((product: any) => ({
        ...product,
        quantity: 1,
        amountDiscount: product.amountDiscount || 0
    }));
};
